/** Customer-facing product name (repo / infra may still use "vera"). */
export const PRODUCT_NAME = "Forma Code Compliance";

/** Short label when the full name is too long (buttons, tight UI). */
export const PRODUCT_ABBR = "FC2";
